import styled from 'styled-components'

export const NoticeIcon = styled.svg`
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  margin-right: 8px;
  color: var(--notice__icon);
`

export const ContentLayout = styled.div`
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes.C};
  align-items: flex-start;
`
